import { useMemo } from 'react';
import { api, type RequestOptions } from '../../lib/api';
import { useSession } from '../../lib/useSession';

type Opts = Omit<RequestOptions, 'method' | 'body' | 'orgId'>;

/** Cliente de `api` con la organización activa en `X-Org-Id` (el backend la valida contra el token). */
export function useOrgApi() {
  const { activeOrg } = useSession();
  const orgId = activeOrg?.orgId;
  return useMemo(
    () => ({
      orgId,
      get: <T>(path: string, o?: Opts) => api.get<T>(path, { ...o, orgId }),
      post: <T>(path: string, body?: unknown, o?: Opts) => api.post<T>(path, body, { ...o, orgId }),
      patch: <T>(path: string, body?: unknown, o?: Opts) => api.patch<T>(path, body, { ...o, orgId }),
      del: <T>(path: string, o?: Opts) => api.del<T>(path, { ...o, orgId }),
    }),
    [orgId],
  );
}

export type OrgApi = ReturnType<typeof useOrgApi>;
